import { useState } from 'react';

import { BillingRegion } from '../components/BillingRegion';
import { TariffsCard } from '../components/TariffsCard';
import { billingCopy } from '../copy';
import { useTariffs } from '../hooks';
import { TabColumn } from './TabColumn';

/**
 * Tarieven: wat het bedrijf zijn klanten per dienst rekent, met de vergoeding
 * voor de inspecteur. Publiceren en wijzigen doet de eigenaar.
 */
export function TariffsTab({ canManage }: { canManage: boolean }) {
    const tariffs = useTariffs();
    const [today] = useState(() => localDate(new Date()));

    return (
        <TabColumn>
            <BillingRegion title={billingCopy.tariffsTitle} query={tariffs}>
                {tariffs.data ? (
                    <TariffsCard tariffs={tariffs.data} canManage={canManage} today={today} />
                ) : null}
            </BillingRegion>
        </TabColumn>
    );
}

/** `YYYY-MM-DD` in de tijdzone van het apparaat. */
function localDate(date: Date): string {
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${date.getFullYear()}-${month}-${day}`;
}
